// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__3aUjI","Question":"ActiveQuiz_Question__1E6bT"};